function splitSig(inputSig) {
  var sig = inputSig.startsWith('0x') ? inputSig.slice(2) : inputSig;
  var r = "0x".concat(sig.substring(0, 64));
  var s = "0x".concat(sig.substring(64, 128));
  var v = parseInt(sig.substring(128, 130), 16);
  if (v < 27) v += 27; // 02 mode is GETH

  var pack = '0x02'.concat(v.toString(16), "000000000000000000000000000000000000000000000000000000000000");
  return [pack, r, s];
}

module.exports = splitSig;